import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AsyncApiService {

  constructor(private http: HttpClient) { }
  isEmailUnique(username: any) {
    return lastValueFrom(this.http.get(`/users/isEmailUnique/${username}`));
  }
}
